import React from "react";
import s from "./style.module.css";
import useVizualisation from "../../../../helpers/useVizualisation";
import Vizualisation from "../../../../components/Vizualisation";

const ExampleChart = ({
  data,
  title,
  note,
  source,
  value,
  size = "default",
}) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  return (
    <Vizualisation className={s.viz} ref={ref} size={size}>
      <div className={s.wrap}>
        <p>inView: {inView ? "TRUE" : "FALSE"}</p>
        <p>Size: {size}</p>
        <p>width: {width}</p>
        <p>height: {height}</p>
        <p>windowSize width: {windowSize.width}</p>
        <p>windowSize height: {windowSize.height}</p>
        <p>value: {value}</p>
      </div>
    </Vizualisation>
  );
};

export default ExampleChart;
